export function parseMoney(value) {
  const raw = String(value).trim().replace(/^R\$\s*/, "")
  let normalized

  if (raw.includes(",")) {
    if (/^(?:\d{1,3}(?:\.\d{3})+|\d+)(?:,\d{1,2})?$/.test(raw)) {
      normalized = raw.replaceAll(".", "").replace(",", ".")
    }
  } else if (/^\d{1,3}(?:\.\d{3})+$/.test(raw)) {
    normalized = raw.replaceAll(".", "")
  } else if (/^\d+(?:\.\d{1,2})?$/.test(raw)) {
    normalized = raw
  }

  if (normalized === undefined) return null
  const amount = Number(normalized)
  return Number.isFinite(amount) && amount <= 99999999.99 ? amount : null
}

export function formatMoney(value) {
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value)
}
